import authMessages from "./auth";
import toastMessages from "./toast";

const appMessages = {
  ...authMessages,
  ...toastMessages
}

export default appMessages;